import React, { useState, useEffect, useRef, useDebugValue } from 'react';
import { Tabs, Form, Button, message, Modal } from 'antd';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
import CancellationDetail from './CancellationDetail';
import CancellationEdit from './CancellationEdit';
import DeadLineDetail from './DeadLineDetail';
import DeadLineEdit from './DeadLineEdit';
import PenaltyDetail from './PenaltyDetail';
import PenaltyEdit from './PenaltyEdit';
import { updatePolicyCancellation, deletePolicyCancellation } from './../../../../../services/policy';
import Loading from './../../../../Loading';
import './index.css';
import moment from 'moment';

const { TabPane } = Tabs;
interface propsTypes {
    isEditable: void | any,
    cancelEditable: void | any
    cancellationDetails: void | any,
    setOperationType: void | any,
    setActiveTabKey: void | any,
    supplier: string,
    propertyId: string,
    getPoliciesData: any,
    setPoliciesData: void | any
}
const format = "MM/DD/YYYY"
const CancellationTab = (props: propsTypes) => {
    const detailRef = useRef({ resetData: () => { }, valueList: [] });
    const [activeSubCancellationTab, setActiveSubCancellationTab] = useState('Detail')
    const changeTab = (key: string) => setActiveSubCancellationTab(key)
    const [details, setDetails] = useState({ ...props.cancellationDetails, ...props?.cancellationDetails?.penalty })
    const [eidtFlag, setEditFlag] = useState(false)
    const [refreshCount, setRefreshCount] = useState(0)
    const [loadingFlag, setLoadingFlag] = useState(false)
    const [disableFlag, setDisableFlag] = useState(false)
    const [ dateValidation, setDateValidation] = useState(true)

    const toggleToEditMode = () => {
        props.isEditable()
        setEditFlag(true);
        setRefreshCount(refreshCount + 1)
    }
    const toggleToViewMode = () => {
        props.cancelEditable()
        setEditFlag(false);
    }
    const [form] = Form.useForm();

    useEffect(() => {}, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [refreshCount])

    const cancelEdit = () => {
        toggleToViewMode()
        form.resetFields();
        detailRef.current.resetData();
    }

    const ModalHead = () => {
        return (
            <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                height: '50px',
                lineHeight: '50px',
                textIndent: '10px',
                borderBottom: '1px solid #ccc',
                color: '#fff',
                background: '#06789D',
                fontSize: 18,
                width: '100%'
            }}>Confirm</div>
        )
    }

    const validateForm = () => {
      form.validateFields().then((e) => {
        if (!dateValidation) { 
          setDisableFlag(true)
        } else {
          setDisableFlag(false)
        }
      }).catch(err => {
          err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
      });
    }

    useEffect(validateForm, [dateValidation])

    useEffect(validateForm, 
    // eslint-disable-next-line react-hooks/exhaustive-deps     
    [])

    const deleteCancellationPolicy = () => {
        const deleteTitle = form.getFieldValue('deleteTitle')
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete ${deleteTitle} ?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk() {
                setLoadingFlag(true)
                const requestBody = {
                    supplier: props.supplier,
                    propertyId: props.propertyId,
                    property: {
                        policies: {
                            cancelpolicy: [
                                {
                                    cancelid: form.getFieldValue('cancelid'),
                                    cancellangid: form.getFieldValue('cancellangid')
                                }
                            ]
                        }
                    }
                }

                deletePolicyCancellation(requestBody).then(res => {
                    setLoadingFlag(false)
                    if (res.result.success) {
                        toggleToViewMode()
                        props.setPoliciesData({})
                        props.getPoliciesData('Cancellation')
                    } else {
                        message.error({
                            content: res?.error[0]?.message || 'operation failed'
                        });
                    }

                }, err => {
                    setLoadingFlag(false)
                    // props.setPoliciesData({})
                    // props.getPoliciesData('Cancellation')
                    message.error({
                        content: err?.message || err?.error[0]?.message
                    });
                })
            },
            onCancel() {
                setLoadingFlag(false)
            },
        });
    }

    const saveCancellation = () => {
        form.validateFields().then(values => {
            if (!dateValidation) {
              setDisableFlag(true)
              return
            }
            setLoadingFlag(true)
            const applicalbeDays: any = detailRef.current.valueList
            const formData = {
                supplier: props.supplier,
                propertyId: props.propertyId,
                property: {
                    policies: {
                        cancelpolicy: [
                            {
                                cancelid: values.cancelid,
                                cancellangid: values.cancellangid,
                                policycode: values.policycode,
                                startdate: values?.startdate ? values?.startdate?.format(format) : null,
                                enddate: values?.enddate ? values?.enddate?.format(format) : null,
                                roomtypecode: values.roomtypecode,
                                nonrefundable: values.nonrefundable,
                                deadlinetype: values.deadlinetype,
                                timeunit: values.timeunit,
                                noofunits: values.noofunits,
                                cancelmethod: values.cancelmethod,
                                cancelTime: values.cancelTime?.format('HH:mm'),
                                chargetype: values.chargetype,
                                chargeamount: values.chargeamount ? values.chargeamount : null,
                                chargepercent: values.chargepercent ? values.chargepercent : null,
                                chargenights: values.chargenights ? values.chargenights : null,
                                currency: values.currency,
                                description: values.description,
                                taxinclusive: values.taxinclusive === 'true' ? true : (values.taxinclusive === 'false' ? false : null),
                                feeinclusive: values.feeinclusive === 'true' ? true : (values.feeinclusive === 'false' ? false : null),
                                monday: applicalbeDays[0].value,
                                tuesday: applicalbeDays[1].value,
                                wednesday: applicalbeDays[2].value,
                                thursday: applicalbeDays[3].value,
                                friday: applicalbeDays[4].value,
                                saturday: applicalbeDays[5].value,
                                sunday: applicalbeDays[6].value,
                            }
                        ]
                    }
                }
            }
            updatePolicyCancellation(formData).then(response => {
                if (response.result.success) {
                    let cancelTime = moment(formData.property.policies.cancelpolicy[0].cancelTime, 'HH:mm')
                    setLoadingFlag(false)
                    setDetails({
                        ...formData.property.policies.cancelpolicy[0],
                        cancelTime,
                        valueList: applicalbeDays,
                        start: values.startdate ? values?.startdate?.format(format) : null,
                        end: values.enddate ? values?.enddate?.format(format) : null,
                        taxinclusive: values.taxinclusive,
                        feeinclusive: values.feeinclusive,
                    })
                    toggleToViewMode()
                    setRefreshCount(refreshCount + 1)
                } else {
                    message.error({
                        content: response?.error[0]?.message
                    });
                    setLoadingFlag(false)
                }
            }, err => {
                setLoadingFlag(false)
                props.cancelEditable()
                //setDetails({...formData,valueList:applicalbeDays})
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
                // toggleToViewMode()
                // setRefreshCount(refreshCount+1)
            })


        }, err => {
            // let errorNameArray:string [] = []
            // err.errorFields.map((item: { name: any; })=>{
            //     errorNameArray.push(item.name[0])
            // })
            // message.error({
            //     content: 'Check all the fields please.',
            // });
            //err.errorFields
        })



    }

    return (
      <Form
        form={form}
        layout='vertical'
        initialValues={details}
        className='no-padding-form'
        onValuesChange={validateForm}>
        <Tabs defaultActiveKey={activeSubCancellationTab} onChange={changeTab}>
          <TabPane
            tab='Detail'
            key='cance llationDetail'
            forceRender={true}
          >
            {eidtFlag ? (
              <CancellationEdit
                cancellationDetails={details}
                toggleToViewMode={toggleToViewMode}
                setDetails={setDetails}
                setDateValidation= {(e: boolean) => {
                  setDateValidation(e)
                }}
                currentForm={form}
                ref={detailRef}
              />
            ) : (
              <CancellationDetail
                cancellationDetails={details}
                toggleToEditMode={toggleToEditMode}
                cancelEditable={props.cancelEditable}
                setActiveTabKey={props.setActiveTabKey}
              />
            )}
          </TabPane>
          <TabPane
            tab='Deadline'
            key='cancellationDeadline'
            forceRender={true}
          >
            {eidtFlag ? (
              <DeadLineEdit cancellationDetails={details} />
            ) : (
              <DeadLineDetail
                cancellationDetails={details}
                toggleToEditMode={toggleToEditMode}
                setActiveTabKey={props.setActiveTabKey}
              />
            )}
          </TabPane>
          <TabPane
            tab='Penalty'
            key='cancellationPenalty'
            forceRender={true}
          >
            {eidtFlag ? (
              <PenaltyEdit
                cancellationDetails={details}
                toggleToViewMode={toggleToViewMode}
                setDetails={setDetails}
                currentForm={form}
              />
            ) : (
              <PenaltyDetail
                cancellationDetails={details}
                toggleToEditMode={toggleToEditMode}
                cancelEditable={props.cancelEditable}
                setActiveTabKey={props.setActiveTabKey}
              />
            )}
          </TabPane>
        </Tabs>
        <ActionButtonsBar
          onDelete={deleteCancellationPolicy}
          onCancel={cancelEdit}
          onSave={saveCancellation}
          disabledSave={disableFlag}
          show={eidtFlag}
          warningMsg={true}
        />
        {loadingFlag && (
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
            }}>
            <Loading type='large' />
          </div>
        )}
      </Form>
    )
}

export default CancellationTab;

